import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import CustomToaster from '@components/CustomToaster';
import { useCurrentUser } from '@hooks';

import AddTopicForm from './AddTopicForm';
import TopicList from './TopicList';

const queryClient = new QueryClient();

const EditTopicsSettings = () => {
  const { currentUser } = useCurrentUser();

  return (
    <QueryClientProvider client={queryClient}>
      <div className="prefs-section-header">
        <h3>Topics You Follow on the Information</h3>
      </div>

      <AddTopicForm identityId={currentUser.identity_id} />

      <div className="mt3 mb4">
        <TopicList identityId={currentUser.identity_id} />
      </div>

      <CustomToaster />
    </QueryClientProvider>
  );
};

export default EditTopicsSettings;
